import { useAtom, useAtomValue } from "jotai";
import { useEffect, useRef, useState } from "react";
import { Oval } from "react-loader-spinner";
import styles from "src/features/Event/components/TopPageScrollIndicator/topPageScrollIndicator.module.css";
import {
    isFirstFetchAtom,
    isLoadedLastPageAtom,
    topPageEventListObjectAtom,
} from "../../event.atom";

type TopPageScrollIndicatorProps = {};

const TopPageScrollIndicator: React.FC<TopPageScrollIndicatorProps> = () => {
    const ref = useRef<HTMLDivElement>(null);
    const [inView, setInView] = useState(false);
    const isFirstFetch = useAtomValue(isFirstFetchAtom);
    const isLoadedLastPage = useAtomValue(isLoadedLastPageAtom);

    const [topPageEventListObject, setTopPageEventListObject] = useAtom(
        topPageEventListObjectAtom
    );

    const isEmpty = Object.keys(topPageEventListObject).length === 0;

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        const observer = new IntersectionObserver(([entry]) => {
            const isView = isFirstFetch && entry.isIntersecting;
            return setInView(isView);
        });
        observer.observe(ref.current);

        if (inView && !isLoadedLastPage) {
            setTopPageEventListObject(false);
        }

        // eslint-disable-next-line consistent-return
        return () => {
            observer.disconnect();
        };
    }, [
        inView,
        isFirstFetch,
        isLoadedLastPage,
        setInView,
        setTopPageEventListObject,
    ]);

    if (isLoadedLastPage) {
        return (
            <div className={styles.text_container}>
                <p>
                    {isEmpty
                        ? "イベントが見つかりませんでした"
                        : "最後まで読み込みました"}
                </p>
            </div>
        );
    }

    return (
        <div className={styles.container} ref={ref}>
            <Oval
                height="3rem"
                width="4rem"
                color="#3CF2FF"
                secondaryColor="#90F8FF"
                ariaLabel="loading-Indicator"
                visible
            />
        </div>
    );
};

export default TopPageScrollIndicator;
